import { Box, Typography } from '@mui/material'

import bafaKfwLogos from '../../assets/bafa-kfw-logos.png'
import {
  ENERGY_MEASURES_COLUMNS,
  ENERGY_MEASURES_ROWS,
  FUNDING_TITLE,
} from '../../constants/funding-overview.constants'

import FundingTable from './FundingTable'
import HeatingFundingSection from './HeatingFundingSection'
import MaxEligibleExpensesBox from './MaxEligibleExpensesBox'

const SECTION_LABEL_SX = {
  fontSize: '12px',
  fontWeight: 500,
  color: '#464A54',
  marginBottom: '8px',
}

const FundingOverview = () => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '16px',
          marginBottom: '24px',
        }}
      >
        <Typography
          sx={{ fontWeight: 600, fontSize: '16px', lineHeight: '24px', maxWidth: '360px' }}
        >
          {FUNDING_TITLE}
        </Typography>
        <Box
          component="img"
          src={bafaKfwLogos}
          alt="Bundesamt für Wirtschaft und Ausfuhrkontrolle und KfW"
          sx={{ height: '45px', flexShrink: 0 }}
        />
      </Box>

      <Typography sx={SECTION_LABEL_SX}>Energetische Maßnahmen</Typography>
      <FundingTable columns={ENERGY_MEASURES_COLUMNS} rows={ENERGY_MEASURES_ROWS} />
      <MaxEligibleExpensesBox />

      <Typography sx={{ ...SECTION_LABEL_SX, marginTop: '40px' }}>Heizungstechnik</Typography>
      <HeatingFundingSection />
    </Box>
  )
}

export default FundingOverview
